import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export class BrandKit extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) return `/mail/brandkits`;
        return `/mail/organizations/${organizationId}/brandkits`;
    }

    get status() {
        return {
            color: this.object.enabled ? 'green' : 'gray',
            text: this.object.enabled ? 'enabled' : 'disabled'
        };
    }

    enable() {
        let url = !this.organization ? `/mail/brandkits` : `/mail/organizations/${this.organization}/brandkits`;
        return fetcher.post(`${url}/${this.pk}/enable`);
    }

    disable() {
        let url = !this.organization ? `/mail/brandkits` : `/mail/organizations/${this.organization}/brandkits`;
        return fetcher.post(`${url}/${this.pk}/disable`);
    }
}
